import EFPicture from '@elem/compCommon/EFPicture';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import QuestionModal from '../../components/QuestionModal';
import SuccessModal from '../../components/SuccessModal';
import { useDP3Store } from '../../DP3Provider';
import Free300 from './icons/Free300';
import Free500 from './icons/Free500';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { subscribeShopify } from '@/service/common';
import { getPagesPrivacyPolicy } from '@/utils/common';

const TheComp: React.FC<{
    status?: string;
}> = ({ status }) => {
    const { pageStatus } = useDP3Store();
    const { useState, useEffect, useLang, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('dp3.teaser.Recommend');
    const { locale, query } = useRouter();
    const [input, setInput] = useState('');
    const [inputHolder, setInputHolder] = useState('');
    const [msg, setMsg] = useState('');
    const [check, setCheck] = useState(true);
    const [questionText, setQuestionText] = useState('');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const isTEASER = pageStatus === IPageStatus.statusA;
    const isCROWDFUNDING = pageStatus === IPageStatus.statusB;
    const nowTime = query?.timer ? new Date(query.timer).getTime() : new Date().getTime();
    const isHideWarranty =
        ['us', 'ca', 'br', 'mx'].includes(locale) &&
        nowTime &&
        nowTime >= new Date('2024/07/24 15:00:00 GMT+8').getTime() &&
        nowTime < new Date('2024/09/01 15:00:00 GMT+8').getTime();

    const [memoTextStage, setMemoTextStaget] = useState(-1);
    const isOnTime = nowTime >= new Date('2024/09/09 15:00:00 GMT+8').getTime();
    // 首要2个
    const lists = [
        {
            // img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719041225881/B1%20(1).png',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724920767221/B1.png',
            text: t('card1_title'),
            desc: t('card1_desc'),
        },
        {
            // img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717494315732/B2%20(1).png',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724920773282/B2.png',
            text: t('card2_title'),
            desc: t('card2_desc'),
        },
    ];

    const PRODUCT3_MAP: any = {
        us: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717230567710/sg4000.png',
        ca: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717230567894/ts.png',
    };

    const ICON_MAP: any = {
        us: <Free300 />,
        ca: <Free500 />,
    };

    let cards = [
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717762158259/sl_DP3EB%20(1).png',
            title: t('card3_title'),
            desc: t('card3_desc'),
            tag: <Free300 />,
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717211864817/sl_shp2.png',
            title: t('card4_title'),
            desc: t('card4_desc'),
            tag: ICON_MAP[locale] || ICON_MAP['us'],
        },
        {
            img: PRODUCT3_MAP[locale] || PRODUCT3_MAP['us'],
            title: t('card5_title'),
            desc: t('card5_desc'),
            tag: <Free300 />,
        },
    ];

    if (locale === 'mx') {
        cards = [
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717762158259/sl_DP3EB%20(1).png',
                title: t('card3_title'),
                desc: t('card3_desc'),
                tag: <Free300 />,
            },
            {
                img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717211864817/sl_shp2.png',
                title: t('card4_title'),
                desc: t('card4_desc'),
                tag: ICON_MAP[locale] || ICON_MAP['us'],
            },
        ];
    }

    // const items = isHideWarranty
    //     ? locale === 'ca'
    //         ? []
    //         : [
    //               {
    //                   icon: <Affirm />,
    //                   title: t('card7_title'),
    //                   desc: t('card7_desc'),
    //               },
    //           ]
    //     : locale === 'ca'
    //     ? [
    //           {
    //               icon: <Warranty />,
    //               tag: <Free549 />,
    //               title: t('card6_title'),
    //               desc: t('card6_desc'),
    //           },
    //       ]
    //     : [
    //           {
    //               icon: <Warranty />,
    //               tag: <Free399 />,
    //               title: t('card6_title'),
    //               desc: t('card6_desc'),
    //           },
    //           {
    //               icon: <Affirm />,
    //               title: t('card7_title'),
    //               desc: t('card7_desc'),
    //           },
    //       ];

    const handleInputChange = (e: any) => {
        setInput(e.target.value);
        setInputHolder(e.target.value);
    };
    const items: any[] = [];

    const handleInputFocus = () => {
        if (msg && msg === t('subscribe_input_error')) setMsg('');
    };

    const handleCheck = (e: any) => {
        if (e.target.className === 'link') {
            return e.stopPropagation();
        }
        if (!check && msg === t('subscribe_check')) {
            setMsg('');
        }
        setCheck(!check);
    };

    const handleSubmit = async () => {
        const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(input.trim())) {
            return setMsg(t('subscribe_input_error'));
        }
        if (!check) {
            return setMsg(t('subscribe_check'));
        }

        try {
            const date = new Date();

            // 格式化时间
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const dateString = `${year}-${month}-${day}`;

            // 订阅SMS
            let dataSMS = {
                email: input.trim(),
                contactListId: '1705576574',
                fields: [
                    // SMS
                    {
                        id: '10791',
                        type: 'text',
                        overwrite: true,
                        value: dateString,
                    },
                    {
                        id: '10615',
                        type: 'multiple',
                        value: [3],
                        overwrite: false,
                    },
                    {
                        id: locale === 'us' ? '4423' : locale === 'ca' ? '4424' : '',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                    {
                        id: '31',
                        type: 'single',
                        value: 1,
                        overwrite: true,
                    },
                ],
            };
            if (locale === 'jp') {
                dataSMS = {
                    email: input.trim(),
                    contactListId: '180562521',
                    fields: [
                        // SMS
                        {
                            id: '9157',
                            type: 'multiple',
                            value: [2],
                            overwrite: true,
                        },
                        {
                            id: '31',
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                        {
                            id: '4431',
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                    ],
                };
            }
            const res = await subscribeShopify(dataSMS, locale, {
                sector_name: t('title'),
                entry_position: 2,
            });
            if (res?.code === '0') {
                setInput('');
                setShowSuccessModal(true);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('subscribe_btn'),
                    status: 'success',
                    tag: 'Agree',
                });
            } else {
                setMsg(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('subscribe_btn'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            setMsg(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('subscribe_btn'),
                status: 'fail',
                tag: 'Agree',
            });
        }
    };

    const handleClose = () => {
        setShowSuccessModal(false);
        setInputHolder('');
    };
    // 点击众筹的buy now
    const changeToBuyHandle = () => {
        if (['br', 'mx'].includes(locale)) {
            let linkMap: { [key: string]: string } = {
                br: 'https://br.ecoflow.com/collections/delta-series-portable-power-stations',
                mx: 'https://mx.ecoflow.com/products/delta-pro-3-portable-power-station',
            };
            return window.open(linkMap[locale] || linkMap.br, '_blank');
        } else {
            editorEventsBus.emit('dp3-tab-change', 'bundles');
            gtm.push({
                event: 'uaEvent',
                event_name: 'jump_button',
                position: 'Inpage',
                button_name: 'Buy Now',
                url: 'None',
            });
        }
    };

    useEffect(() => {
        setMemoTextStaget(
            ['us', 'ca', 'br', 'mx'].includes(locale)
                ? nowTime < new Date('2024/07/16 15:00:00 GMT+8').getTime()
                    ? 0
                    : nowTime >= new Date('2024/07/16 15:00:00 GMT+8').getTime() && nowTime < new Date('2024/07/18 15:00:00 GMT+8').getTime()
                    ? 1
                    : nowTime >= new Date('2024/07/18 15:00:00 GMT+8').getTime() && nowTime < new Date('2024/07/23 15:00:00 GMT+8').getTime()
                    ? 2
                    : -1
                : -1,
        );
    }, [locale, query]);

    return (
        <div id="dp3-teaser-B" className={`${css.thecomp} dp3-module-box dp3-teaser-B`}>
            {isTEASER && <h2 className="dp3-title">{t('title')}</h2>}
            {isCROWDFUNDING && <h2 className="dp3-title">{t(isOnTime ? 'title_crowdfunding2' : 'title_crowdfunding')}</h2>}
            {/* {isCROWDFUNDING && !isOnTime && (
                <p className="dp3-desc">
                    {t.rich('desc_crowdfunding', {
                        o: (tx: string) => <span className="o">{tx}</span>,
                    })}
                </p>
            )} */}
            {isCROWDFUNDING && memoTextStage !== -1 && (
                <p className={`dp3-memo${memoTextStage === 1 ? ' rich' : ''}`}>
                    {t.rich(memoTextStage === 0 ? 'memo' : memoTextStage === 1 ? 'memo1' : 'memo2', {
                        c: (tx: any) => <span className="c">{tx}</span>,
                    })}
                    {memoTextStage === 1 && (
                        <span
                            className="question"
                            onClick={() =>
                                setQuestionText(
                                    t.rich('memo1_desc', {
                                        c: (tx: any) => <span className="c">{tx}</span>,
                                        s: (tx: any) => <span className="s">{tx}</span>,
                                    }),
                                )
                            }
                        >
                            {/* <Question /> */}
                        </span>
                    )}
                </p>
            )}
            {isTEASER && (
                <div className="control suscribe-now">
                    <div className="input-box">
                        <input
                            type="text"
                            className="input"
                            value={input}
                            placeholder={t('subscribe_placeholder')}
                            onChange={handleInputChange}
                            onFocus={handleInputFocus}
                        />
                        <button className="subscribe" onClick={handleSubmit}>
                            {t('subscribe_btn')}
                        </button>
                    </div>
                    {msg && <p className="error-msg">{msg}</p>}
                    <div className="terms" onClick={handleCheck}>
                        <input type="checkbox" className="check" checked={check} readOnly />
                        <p className="terms-text">
                            {t.rich('subscribe_terms', {
                                a1: (text: string) => (
                                    <Link className="link" href={getPagesPrivacyPolicy(locale)} target="_blank">
                                        {text}
                                    </Link>
                                ),
                                a2: (text: string) => (
                                    <Link className="link" href={`https://${locale}.ecoflow.com/pages/terms-of-use`} target="_blank">
                                        {text}
                                    </Link>
                                ),
                            })}
                        </p>
                    </div>
                </div>
            )}
            {isCROWDFUNDING && !['br', 'mx'].includes(locale) && (
                <div className="comp-btn-line-a">
                    <button className="dp3-btn" onClick={changeToBuyHandle}>
                        {locale === 'br' ? 'Comprar' : locale === 'mx' ? 'Comprar ahora' : `Buy Now`}
                    </button>
                </div>
            )}
            <div className="lists-box">
                {status === 'teaser' && <p className="lists-title">{t('lists_title')}</p>}
                <ul className="lists">
                    {lists?.map((list: any, k: number) => (
                        <li className="list" key={k}>
                            {/* <div className="question" onClick={() => setQuestionText(list?.desc)}>
                                <Question />
                            </div> */}
                            <div className="list-img">
                                <EFPicture src={`${list?.img}`} alt={list.text} />
                            </div>
                            <p className="list-text">{list.text}</p>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="cards-box pc">
                <ul className="cards">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            {/* <div className="off">{card.tag}</div> */}
                            {/* <div className="question" onClick={() => setQuestionText(card?.desc)}>
                                <Question />
                            </div> */}
                            <div className="card-img">
                                <EFPicture src={card?.img} alt={card.title} />
                            </div>
                            <p className="card-title">{card?.title}</p>
                        </li>
                    ))}
                </ul>
                {items?.length > 0 && (
                    <ul className="items">
                        {items?.map((item: any, k: number) => (
                            <li className={`item ${isHideWarranty ? 'single' : ''}`} key={k}>
                                {/* {item.tag && <div className="off">{item.tag}</div>} */}
                                {/* <div className="question" onClick={() => setQuestionText(item?.desc)}>
                                    <Question />
                                </div> */}
                                <div className="item-icon">{item?.icon}</div>
                                <p className="item-title">{item?.title}</p>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <ul className={`cards-box h5 ${isHideWarranty ? 'single' : ''}`}>
                {new Array(locale === 'mx' ? 2 : 3).fill(1)?.map((card: any, k: number) => (
                    <li className="card" key={k}>
                        {/* {k < 3 && <div className="off">{cards[k]?.tag}</div>} */}
                        {/* {k >= 3 && <div className="off">{items[k - (isHideWarranty && k === 3 ? 4 : 3)]?.tag}</div>} */}
                        {/* <div className="question" onClick={() => setQuestionText(t(`card${k + (isHideWarranty && k === 3 ? 4 : 3)}_desc`))}>
                            <Question />
                        </div> */}
                        <div className="card-img">{<EFPicture src={cards[k]?.img} alt={cards[k]?.title} />}</div>
                        <p className="card-title">{t(`card${k + (isHideWarranty && k === 3 ? 4 : 3)}_title`)}</p>
                    </li>
                ))}
            </ul>

            {questionText && <QuestionModal text={questionText} callback={() => setQuestionText('')} />}
            {showSuccessModal && <SuccessModal input={inputHolder} link="https://bit.ly/3K4z0vC" callback={handleClose} />}
        </div>
    );
};

export default TheComp;
